module.exports = __webpack_public_path__ + "static/img/user.1783997848725.png";